import React from 'react';
import { CTABand } from '../../components/CTABand';
export function CompetitionFinalCTA() {
  return <CTABand headline="Ready to Step on the Mat?" copy="If you are a current student interested in competing, or an experienced athlete looking for a new team, contact us to discuss tryout opportunities." data-id="element-805" />;
}